import { render, staticRenderFns } from "./SysProperty.vue?vue&type=template&id=39d511c8&scoped=true"
import script from "./SysProperty.vue?vue&type=script&lang=js"
export * from "./SysProperty.vue?vue&type=script&lang=js"
import style0 from "./SysProperty.vue?vue&type=style&index=0&id=39d511c8&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d511c8",
  null
  
)

export default component.exports